import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

export function TaxAdjustmentExistsColumnFormatter(cellContent) {
  const {isOtherIncomeExists, taxAdjustmentFileExists} = cellContent;

  if (isOtherIncomeExists) {
    if (taxAdjustmentFileExists) {
      return (
        <div className={'font-weight-bolder font-size-lg text-nowrap'} style={{color: '#28a745'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Check.svg')}
            alt="icon"
            className={'mr-2'}
          />
          <FormattedMessage id={'label-exists'} defaultMessage="Exists"/>
        </div>
      )
    } else {
      return (
        <div className={'font-weight-bolder font-size-lg text-nowrap'} style={{color: '#dc3545'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Cross.svg')}
            alt="icon"
            className={'mr-2'}
          />
          <FormattedMessage id={'label-does-not-exist'} defaultMessage="Does not exist"/>
        </div>
      )
    }
  } else {
    return (
      <div className={'font-weight-bolder font-size-lg text-nowrap'} style={{color: '#FF8303'}}>
        <img
          src={toAbsoluteUrl('/media/svg/Circle_orange.svg')}
          alt="icon"
          className={'mr-2'}
        />
        <FormattedMessage id={'label-not-needed'} defaultMessage="Not needed"/>
      </div>
    )
  }
}
